import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "call-controls" }

interface Props {
  isAudioEnabled: boolean;
  isVideoEnabled: boolean;
  // Recording props hidden per user request
  // isRecording?: boolean;
  // recordingStatus?: "idle" | "recording" | "paused";
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallControls',
  props: {
    isAudioEnabled: { type: Boolean },
    isVideoEnabled: { type: Boolean }
  },
  emits: ["toggle-audio", "toggle-video", "end-call"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      color: __props.isAudioEnabled ? 'primary' : 'error',
      icon: "",
      size: "large",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-audio')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.isAudioEnabled ? "mdi-microphone" : "mdi-microphone-off"), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["color"]),
    _createVNode(_component_v_btn, {
      color: __props.isVideoEnabled ? 'primary' : 'error',
      icon: "",
      size: "large",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-video')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.isVideoEnabled ? "mdi-video" : "mdi-video-off"), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["color"]),
    _createVNode(_component_v_btn, {
      color: "error",
      icon: "",
      size: "x-large",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('end-call')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("mdi-phone-hangup", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})